import { render, staticRenderFns } from "./scrollPane.vue?vue&type=template&id=42c640fb&scoped=true&"
import script from "./scrollPane.vue?vue&type=script&lang=js&"
export * from "./scrollPane.vue?vue&type=script&lang=js&"
import style0 from "./scrollPane.vue?vue&type=style&index=0&id=42c640fb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c640fb",
  null
  
)

export default component.exports